import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import list from './list.js'

export default contract({
  list: array([
    list
  ])
})
